<template>
  <div v-if="item" class="mt-2">
    <copy-participant-ssn :item="item"></copy-participant-ssn>
    <div class="col-12">
      <span>Name changed to {{item.firstName}} {{item.lastName}}</span>
    </div>
    <div class="col-12">
      <a href="#" @click="download(item.uploadDocumentId1)">View Identity Proof 1</a>
    </div>
    <div class="col-12" v-show="item.uploadDocumentId2 != 0">
      <a href="#" @click="download(item.uploadDocumentId2)">View Identity Proof 2</a>
    </div>
  </div>
</template>

<script>
import CopyParticipantSsn from './CopyParticipantSsn.vue';

export default {
  props: ["item"],
  methods: {
    async download(docId) {
      await romeApi.download(`actionitem/v-2/namechange/${docId}/download`);
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/NameChange.vue